/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TuteurLieuFormationGridDto
 */
export interface TuteurLieuFormationGridDto {
    /**
     * 
     * @type {number}
     * @memberof TuteurLieuFormationGridDto
     */
    idlieuFormation?: number;
    /**
     * 
     * @type {number}
     * @memberof TuteurLieuFormationGridDto
     */
    idsiegeSocial?: number;
    /**
     * 
     * @type {string}
     * @memberof TuteurLieuFormationGridDto
     */
    nom?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TuteurLieuFormationGridDto
     */
    enseigne?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TuteurLieuFormationGridDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TuteurLieuFormationGridDto
     */
    telephone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TuteurLieuFormationGridDto
     */
    localite?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TuteurLieuFormationGridDto
     */
    numeroUe?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TuteurLieuFormationGridDto
     */
    actif?: boolean | null;
}

/**
 * Check if a given object implements the TuteurLieuFormationGridDto interface.
 */
export function instanceOfTuteurLieuFormationGridDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TuteurLieuFormationGridDtoFromJSON(json: any): TuteurLieuFormationGridDto {
    return TuteurLieuFormationGridDtoFromJSONTyped(json, false);
}

export function TuteurLieuFormationGridDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TuteurLieuFormationGridDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idlieuFormation': !exists(json, 'idlieuFormation') ? undefined : json['idlieuFormation'],
        'idsiegeSocial': !exists(json, 'idsiegeSocial') ? undefined : json['idsiegeSocial'],
        'nom': !exists(json, 'nom') ? undefined : json['nom'],
        'enseigne': !exists(json, 'enseigne') ? undefined : json['enseigne'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'telephone': !exists(json, 'telephone') ? undefined : json['telephone'],
        'localite': !exists(json, 'localite') ? undefined : json['localite'],
        'numeroUe': !exists(json, 'numeroUe') ? undefined : json['numeroUe'],
        'actif': !exists(json, 'actif') ? undefined : json['actif'],
    };
}

export function TuteurLieuFormationGridDtoToJSON(value?: TuteurLieuFormationGridDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idlieuFormation': value.idlieuFormation,
        'idsiegeSocial': value.idsiegeSocial,
        'nom': value.nom,
        'enseigne': value.enseigne,
        'email': value.email,
        'telephone': value.telephone,
        'localite': value.localite,
        'numeroUe': value.numeroUe,
        'actif': value.actif,
    };
}

